<template>
  <div class="index">
    <!-- 表头区域 -->
<!--    <PageHeaders></PageHeaders>-->
    <!-- 功能区域 -->
    <div class="body-container flex">
      <router-view />
    </div>
    <!-- 底部区域-->
    <PageBottom></PageBottom>
    <!-- 侧边栏区域 -->
    <RightSide></RightSide>
  </div>
</template>

<script>
import PageHeaders from "@/components/Headers";
import PageBottom from "@/components/PageBottom";
import RightSide from "@/components/rightSide";
export default {
  name: "index",
  props: {},
  components: {PageHeaders, PageBottom, RightSide},
  data() {
    return {}
  },
  // 进入加载，Dom未编译前
  created() {

  },
  // 进入加载，Dom编译完成后
  mounted() {

  },
  // 离开加载
  destroyed() {

  },
  // 监听事件
  watch: {},
  // 计算事件
  computed: {},
  // 方法盒子
  methods: {}
}
</script>

<style scoped lang="scss">
.index {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  background: #f9fcff;
  overflow: hidden;
  position: relative;
  .body-container {
    width: 100%;
    flex: 1;
  }
}
</style>
